import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type PageHeaderProps = {
  readonly title: string;
  readonly subtitle?: string;
  readonly actions?: ReactNode;
  readonly className?: string;
};

/**
 * Cabecalho de pagina (Next-Elite PageHeader) adaptado ao RenkeConnect.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex w-full min-w-0 shrink-0 flex-col gap-4 sm:flex-row sm:items-start sm:justify-between",
        className,
      )}
    >
      <div className="min-w-0 space-y-1">
        <h1 className="text-2xl font-semibold tracking-[-0.02em] text-foreground sm:text-3xl">
          {title}
        </h1>
        {subtitle ? (
          <p className="max-w-3xl text-sm text-muted-foreground sm:text-base">
            {subtitle}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}

type PageLayoutProps = {
  readonly children: ReactNode;
  readonly className?: string;
};

/** Container vertical padrao das telas autenticadas. */
export function PageLayout({ children, className }: PageLayoutProps) {
  return (
    <div className={cn("flex w-full min-w-0 flex-col gap-6", className)}>
      {children}
    </div>
  );
}
